// Used in JS map etc, so 0 index; we eagerly load up to 4 images
const IMAGE_EAGER_LOAD_LIMIT = 3;

const IMAGE_LOADING_BEHAVIOR = {
  EAGER: 'eager',
  LAZY: 'lazy',
};

export { IMAGE_EAGER_LOAD_LIMIT, IMAGE_LOADING_BEHAVIOR };
